<template>
  <b-card style="position: relative">

    <div v-if="loading" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <b-form @submit.prevent="updateAlert" class="repeater-form">
      <b-row>
        <b-col>
          <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0" pills
        nav-wrapper-class="col-md-2 col-12 border rounded p-1" nav-class="nav-left">
            <b-tab :title="$t('Basic Information')" active>
              <info-tab></info-tab>

              <b-col cols="12">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
          >
            {{ $t('Save') }}
          </b-button>
          <!-- <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary">
            {{ $t('Reset') }}
          </b-button> -->
        </b-col>
            </b-tab>
          

            <b-tab :title="$t('Devices')" >
             <LinkDevicesTab :user="auth.id" />

             
            </b-tab>

            <b-tab :title="$t('Geofences')" >
             <LinkGeofenceTab :user="auth.id" />

             
            </b-tab>



           
          </b-tabs>
        </b-col>

        <!-- reset and submit -->
      

      </b-row>


    </b-form>
  </b-card>
</template>

<script>

import { OrbitSpinner } from 'epic-spinners'
import { heightTransition } from '@core/mixins/ui/transition'
import {
  BButton,
  BCard, BCol,
  BForm, BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { computed, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import { AlertStore } from '@/app/alerts/state'
import InfoTab from '@/views/modules/alerts/tabs/InfoTab'
import LinkDevicesTab from '@/views/modules/alerts/tabs/LinkDevicesTab.vue'
import LinkGeofenceTab from '@/views/modules/alerts/tabs/LinkGeofenceTab.vue'
import router from '@/router'




export default {
  name: 'createAlert',
  components: {
    BRow,
    BCard,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    LinkDevicesTab,
    InfoTab,
    LinkGeofenceTab
},
  directives: {
    Ripple,
  },

  setup(props, { root}) {

    const auth = store.state.auth.userData

    const ALERT_STORE = 'alert'

    store.registerModule(ALERT_STORE, AlertStore)

    onUnmounted(() => {
      if (store.hasModule(ALERT_STORE))
          store.unregisterModule(ALERT_STORE)
    })

    store.dispatch('alert/fetchLists', auth.id)
    
    store.dispatch(
        'alert/fetchAlertData',
        router.currentRoute.params.id
    )


     const alertData = computed(() => store.state.alert.data)
     const loading = computed(() => store.state.alert.loading)
      
    const updateAlert = () => {
      store.dispatch('alert/saveData').then(res => {
        root.$bvToast.toast(
            root.$i18n.t("alert updated successfully"), {
              title: `Success`,
              variant: 'success',
            })
      }).catch(reason => {
        
      })
    }


    return {
      alertData,
      loading,
      updateAlert,
      auth
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
